var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1b1b1b;fill-rule:evenodd;stroke:#1b1b1b;stroke-miterlimit:10;stroke-width:.3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.12,5.91h2.49c.42,0,.76.34.76.76v20.54c0,.42-.34.76-.76.76h-11.04c-.42,0-.76-.34-.76-.76V6.66c0-.42.34-.76.76-.76h2.49v-1.26c0-.42.34-.76.76-.76h4.54c.42,0,.76.34.76.76v1.26Zm-5.3-1.6c-.19,0-.35.15-.35.34v1.26h5.23v-1.26c0-.19-.15-.34-.35-.34h-4.54Zm7.79,23.25c.19,0,.35-.15.35-.34V6.66c0-.19-.16-.34-.35-.34h-11.04c-.19,0-.35.15-.35.34v20.54c0,.19.16.34.35.34h11.04Zm-6.49-6.1s.07.03.11.03c.07,0,.13-.03.17-.09l3.44-5.16c.05-.07.05-.16.01-.23l-.07-.12h-2.12l1.15-3.19c.04-.1,0-.22-.1-.27l-.18-.08-4.2,5.2c-.05.07-.06.16-.03.24l.07.13h2.2v.5c0,.11.09.21.21.21s.21-.09.21-.21v-.91h-2.09l3.14-3.88-.97,2.69h2.23l-3.25,4.87c-.06.1-.04.22.06.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricBattery);
export default __webpack_public_path__ + "static/media/Electric_battery.f260c05d4e77cddf647ec109456a3f10.svg";
export { ForwardRef as ReactComponent };